<template>
  <input
    ref="search-input"
    v-debounce:500ms="handleSearchDebounce"
    type="search"
    class="search-input"
    placeholder="Type here to search..."
  />
</template>

<script>
import { vue3Debounce } from "vue-debounce";
import { mapActions } from "vuex";

export default {
  name: "SearchInput",
  directives: {
    debounce: vue3Debounce({ lock: true }),
  },
  inject: ["mq"],
  data() {
    return {
      searchTerm: null,
    };
  },
  mounted() {
    if (this.mq.mdPlus) {
      this.$refs["search-input"].focus();
    }
  },
  methods: {
    ...mapActions("search", ["addSearchTerm"]),
    handleSearchDebounce(value) {
      if (value !== this.searchTerm && value) {
        this.searchTerm = value;
        this.addSearchTerm(value);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search-input {
  border: none;
  outline: none;
  font-size: 12px;
  font-family: $body-font-family;
  width: 100%;
  padding: 10px 0;
  background: 0;

  &::placeholder {
    opacity: 0.6;
  }
}
</style>
